import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { useLocation } from 'react-router-dom';
import { Link } from "../../../Common";
import { Heading } from "../../../Typography";
import * as links from "../../../../constants/links";
import Grid from '../../Grid';
import { useHeaderContext } from '../HeaderContext';
import DropDownMenu from './DropDownMenu';
import styles from './HeaderMobile.scss';

var HeaderMobile = function HeaderMobile(_ref) {
  var navigation = _ref.navigation,
      _ref$navigationTopics = _ref.navigationTopics,
      navigationTopics = _ref$navigationTopics === void 0 ? [] : _ref$navigationTopics,
      additionalContentSlot = _ref.additionalContentSlot,
      notifications = _ref.notifications,
      siteName = _ref.siteName,
      onClickLogin = _ref.onClickLogin,
      onClickLogout = _ref.onClickLogout,
      onClickRegister = _ref.onClickRegister,
      onSubmitSearch = _ref.onSubmitSearch,
      customHandleLangChange = _ref.customHandleLangChange;
  var location = useLocation();

  var _useHeaderContext = useHeaderContext(),
      logoUrl = _useHeaderContext.logoUrl,
      isBeta = _useHeaderContext.isBeta;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpenedBurger = _useState2[0],
      setBurgerState = _useState2[1];

  var handleClickBurger = function handleClickBurger() {
    return setBurgerState(!isOpenedBurger);
  };

  useEffect(function () {
    setBurgerState(false);
  }, [location.pathname]);

  var handleActiveNavLinkClick = function handleActiveNavLinkClick() {
    setBurgerState(false);
    setTimeout(function () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }, 200);
    /* Dropdown close animation time from scss, don't forget to change the timeout if the animation time changes. */
  };

  return /*#__PURE__*/React.createElement("header", {
    className: styles.header
  }, /*#__PURE__*/React.createElement(Grid.Container, null, /*#__PURE__*/React.createElement("div", {
    className: styles.headerInner
  }, /*#__PURE__*/React.createElement(Link, {
    to: links.home,
    className: styles.logoWrap
  }, /*#__PURE__*/React.createElement("img", {
    src: logoUrl,
    alt: "",
    className: styles.logo
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.siteName, _defineProperty({}, styles.beta, isBeta))
  }, /*#__PURE__*/React.createElement(Heading, {
    level: 2
  }, siteName))), /*#__PURE__*/React.createElement("div", {
    className: styles.controls
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.notificationsWrapper
  }, notifications), /*#__PURE__*/React.createElement("div", {
    className: styles.controlWrap
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: handleClickBurger,
    className: classnames(styles.burgerButton, styles.controlItem, _defineProperty({}, styles.isOpened, isOpenedBurger))
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.burgerLine
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.burgerLine
  })))))), /*#__PURE__*/React.createElement(DropDownMenu, {
    isOpened: isOpenedBurger,
    setIsOpened: setBurgerState,
    onSubmitSearch: onSubmitSearch,
    onClickLogin: onClickLogin,
    onClickLogout: onClickLogout,
    onClickRegister: onClickRegister,
    onActiveNavLinkClick: handleActiveNavLinkClick,
    navigation: [].concat(_toConsumableArray(navigationTopics), _toConsumableArray(navigation)),
    additionalContentSlot: additionalContentSlot,
    customHandleLangChange: customHandleLangChange
  }));
};

export default HeaderMobile;